var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsDarkLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4853 26L19.364 35.1213C18.7474 35.7379 17.9293 36.03 17.1217 35.9976C17.0813 35.9992 17.0408 36 17 36H13C11.3431 36 10 34.6569 10 33C10 31.3431 11.3431 30 13 30H16L25.0662 20.9338C25.3233 20.6767 25.6154 20.4761 25.9272 20.3318C26.3386 20.1197 26.8053 20 27.3 20H31C32.6568 20 34 21.3431 34 23C34 24.6569 32.6568 26 31 26H28.4853Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1429 28C29.0383 28 28.1429 28.8954 28.1429 30V31.6543C27.3167 31.9001 26.7143 32.6654 26.7143 33.5714V36C26.7143 37.1046 27.6097 38 28.7143 38H33.2857C34.3903 38 35.2857 37.1046 35.2857 36V33.5714C35.2857 32.6654 34.6833 31.9001 33.8572 31.6543V30C33.8572 28.8954 32.9617 28 31.8571 28H30.1429ZM32.4286 31.5714H29.5714V30.4286C29.5714 29.8763 30.0192 29.4286 30.5714 29.4286H31.4286C31.9809 29.4286 32.4286 29.8763 32.4286 30.4286V31.5714ZM31 33.7143C30.6055 33.7143 30.2857 34.0341 30.2857 34.4286V35.1429C30.2857 35.5373 30.6055 35.8571 31 35.8571C31.3945 35.8571 31.7143 35.5373 31.7143 35.1429V34.4286C31.7143 34.0341 31.3945 33.7143 31 33.7143Z",
    fill: "white",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsDarkLocked);
export default __webpack_public_path__ + "static/media/es-dark-locked.873af9f06f7c64d20df1a0c67c3b306c.svg";
export { ForwardRef as ReactComponent };